// ══════════════════════════════════════════════════════════════
// CONFIGURATION DU SITE
// Modifiez les valeurs ci-dessous pour personnaliser le contenu
// ══════════════════════════════════════════════════════════════

export const SITE_CONFIG = {
  brand: "Prestige Event",
  tagline: "Vivez vos photos",
  heroSubtitle: "Location de photobooths 360° pour vos événements d'exception",
  email: "prestige.events360@gmail.com",
  phone: "+33 1 03 02 03 05",
  availability: "Disponibles du lundi au vendredi, 9h–18h. N'hésitez pas pour toute information.",
};

export const NAV_ITEMS = [
  { label: "Accueil", target: "hero" },
  { label: "À propos", target: "about" },
  { label: "Formules", target: "offers" },
  { label: "Contact", target: "contact" },
];

export interface Offer {
  id: number;
  title: string;
  persons: string;
  price: string;
  duration: string;
  features: string[];
  accent: string;
  popular?: boolean;
}

export const OFFERS: Offer[] = [
  {
    id: 1,
    title: "Essentiel",
    persons: "1-2 PERS",
    price: "290€",
    duration: "5h",
    features: [
      "Photobooth 360° rotatif",
      "Impressions illimitées",
      "Galerie en ligne privée",
      "1 opérateur dédié",
      "Accessoires & props",
    ],
    accent: "#FB8136",
  },
  {
    id: 2,
    title: "Premium",
    persons: "1-4 PERS",
    price: "319€",
    duration: "5h",
    features: [
      "Tout de l'offre Essentiel",
      "iPad de prévisualisation",
      "Partage instantané réseaux",
      "Vidéos slow-motion",
      "Personnalisation overlay",
    ],
    accent: "#DDDCEF",
    popular: true,
  },
  {
    id: 3,
    title: "Prestige",
    persons: "1-7 PERS",
    price: "349€",
    duration: "Soirée complète",
    features: [
      "Tout de l'offre Premium",
      "Durée illimitée",
      "2 opérateurs dédiés",
      "Fond vert & décors",
      "Livraison & installation",
    ],
    accent: "#F2AB46",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sophie & Marc",
    event: "Mariage — Juin 2024",
    text: "Une expérience incroyable ! Nos invités ont adoré le photobooth 360°. Les vidéos sont magnifiques, un vrai souvenir de notre journée.",
    rating: 5,
  },
  {
    name: "Entreprise Luxor",
    event: "Gala d'entreprise — Mars 2024",
    text: "Professionnalisme exemplaire. L'équipe Prestige Event a su s'adapter parfaitement à notre événement corporate haut de gamme.",
    rating: 5,
  },
  {
    name: "Amina B.",
    event: "Anniversaire — Septembre 2024",
    text: "Mes amis parlent encore de la soirée ! Le photobooth a été le clou du spectacle. Qualité au top, je recommande à 100%.",
    rating: 5,
  },
];

export const EVENTS = [
  { icon: "💍", label: "Mariages" },
  { icon: "🎂", label: "Anniversaires" },
  { icon: "🏢", label: "Entreprises" },
  { icon: "🎓", label: "Galas" },
  { icon: "🎉", label: "Soirées privées" },
  { icon: "🎄", label: "Fêtes de fin d'année" },
];

export const STEPS = [
  { num: "01", title: "Réservation", desc: "Choisissez votre formule et la date de votre événement. Nous confirmons sous 24h." },
  { num: "02", title: "Installation", desc: "Notre équipe arrive en avance pour installer le photobooth et tout préparer." },
  { num: "03", title: "L'expérience", desc: "Vos invités profitent d'une expérience immersive 360° avec partage instantané." },
  { num: "04", title: "Souvenirs", desc: "Recevez votre galerie privée en ligne avec toutes les photos et vidéos." },
];
